import Vuex from 'vuex'

import {
  application,
  progressModal,
  user,
  userPassword,
  users,
  userFilters,
  staff,
  staffFilters,
  client,
  clients,
  clientFilters,
  businessEntity,
  businessEntities,
  businessEntityFilters,
  assignment,
  assignments,
  assignmentFilters,
  consultantTimeSheet,
  staffTimeSheet,
  timeCardReport,
  timeCardReportFilters,
  notifications,
  authentication,
  employeeTypes,
  employeePayrollTypes,
  billRateTypes,
  payRateTypes,
  payFrequencies,
  timeTypes,
  directPlacements,
  directPlacementFilters,
  directPlacement,
  commissionsTiers,
  commissionDetailsReport,
  commissionDetailsReportFilters,
  commissionReport,
  commissionReportFilters,
  invoicingReport,
  invoicingReportFilters,
  payrollReport,
  payrollReportFilters,
  directPlacementPayment,
  directPlacementPayments,
  gpToCostReport,
  gpToCostReportFilters,
  dashboard,
  contractTypes,
  invoiceFrequencies,
  dealV2,
  dealFilters,
  dealStatuses,
  dealClient,
  dealCandidate,
  dealAssignment,
  expensesTypes,
  oneOffFeesRecords,
  teams,
  projects,
  thirdPartyPortals,
  settings,
  zohoIntegration,
  placementGoals,
  directPlacementGoals,
  placements,
  placementFilters,
  expenseAmountTypes,
  dashboardLayout,
  biweeklyPeriods,
  periods,
  revenueData,
  consultantsEditedTotalPay,
  staffEditedTotalPay,
  editedTotalBill,
  clockLogs,
  datetimeHelper,
  clockLogsReport,
  timeManagement,
  workflowTemplate,
  workflowTemplates,
  workflowTemplateFilters,
  workflowTemplateTask,
  workflowTemplateTasks,
  workflowTypes,
  workflowInstance,
  workflowInstances,
  workflowInstanceFilters,
  workflowTask,
  workflowTasks,
  workflowTaskFilters,
  workflowDashboard,
  workflowDashboardFilters,
  documentTemplate,
  documentTemplates,
  documentTypes,
  workflowTaskTypes,
  workflowEmailRecipientSources,
  workflowEmailTemplate,
  workflowEmailTemplates,
  workflowLibraryAsset,
  workflowLibraryAssets,
  workflowEmailSends,
  importRun,
  importRuns,
  importRunFilters,
  invoice,
  invoices,
  invoiceFilters,
  importUpload,
  quickBooksConnections
} from './modules'

const store = {
  modules: {
    application,
    progressModal,
    user,
    userPassword,
    users,
    userFilters,
    staff,
    staffFilters,
    client,
    clients,
    clientFilters,
    businessEntity,
    businessEntities,
    businessEntityFilters,
    assignment,
    assignments,
    assignmentFilters,
    consultantTimeSheet,
    staffTimeSheet,
    timeCardReport,
    timeCardReportFilters,
    notifications,
    authentication,
    employeeTypes,
    employeePayrollTypes,
    billRateTypes,
    payFrequencies,
    payRateTypes,
    timeTypes,
    directPlacements,
    directPlacementFilters,
    directPlacement,
    commissionsTiers,
    commissionDetailsReport,
    commissionDetailsReportFilters,
    commissionReport,
    commissionReportFilters,
    invoicingReport,
    invoicingReportFilters,
    payrollReport,
    payrollReportFilters,
    directPlacementPayment,
    directPlacementPayments,
    gpToCostReport,
    gpToCostReportFilters,
    dashboard,
    contractTypes,
    invoiceFrequencies,
    dealV2,
    dealFilters,
    dealStatuses,
    dealClient,
    dealCandidate,
    dealAssignment,
    expensesTypes,
    oneOffFeesRecords,
    teams,
    projects,
    thirdPartyPortals,
    settings,
    zohoIntegration,
    placementGoals,
    directPlacementGoals,
    placements,
    placementFilters,
    expenseAmountTypes,
    dashboardLayout,
    biweeklyPeriods,
    periods,
    revenueData,
    consultantsEditedTotalPay,
    staffEditedTotalPay,
    editedTotalBill,
    clockLogs,
    datetimeHelper,
    clockLogsReport,
    timeManagement,
    workflowTemplate,
    workflowTemplates,
    workflowTemplateFilters,
    workflowTemplateTask,
    workflowTemplateTasks,
    workflowTypes,
    workflowInstance,
    workflowInstances,
    workflowInstanceFilters,
    workflowTask,
    workflowTasks,
    workflowTaskFilters,
    workflowDashboard,
    workflowDashboardFilters,
    documentTemplate,
    documentTemplates,
    documentTypes,
    workflowTaskTypes,
    workflowEmailRecipientSources,
    workflowEmailTemplate,
    workflowEmailTemplates,
    workflowLibraryAsset,
    workflowLibraryAssets,
    workflowEmailSends,
    importRun,
    importRuns,
    importRunFilters,
    invoice,
    invoices,
    invoiceFilters,
    importUpload,
    quickBooksConnections
  }
}

export default () => new Vuex.Store(store)
